export default __webpack_public_path__ + "static/media/budget-calculator.eb8c70aa.png";